import styled from '@emotion/styled'
export const StyleColumn = styled.div`
  width: 40%;
  margin: 0px auto;
  @media (max-width: 1250px) {
    width: 50%;
  }
  @media (max-width: 1024px) {
    width: 70%;
  }
  @media (max-width: 767px) {
    width: 90%;
  }
  @media (max-width: 640px) {
    width: 100%;
  }
`
export const StyleAuthCard = styled.div`
  width: 100%;
  background: ${(props: any) => props.theme.colors.white};
  border-radius: 12px;
`

export const StyleAuthCardWrapper = styled.div`
  padding: 30px 20px;
`
